module.exports = __webpack_public_path__ + "media/images/countrysquared/ne-9834d8a75cb6519c2a48de58622c7dfd.svg";